/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/326-tab': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M15 0h1v8h-1V0zM0 8h1v8H0V8zM5 11h11v2H5v2.5L1.5 12 5 8.5V11zM11 5H0V3h11V.5L14.5 4 11 7.5z"/>'
  }
})
